import type { ComponentPropsWithRef } from "react";

import { cx } from "@/lib/cx";

import styles from "./Kbd.module.css";

/** A key or key combination, e.g. <Kbd>Ctrl</Kbd><Kbd>K</Kbd>. */
export function Kbd({ className, ...props }: ComponentPropsWithRef<"kbd">) {
  return <kbd className={cx(styles.kbd, className)} {...props} />;
}
